import { post } from './request';

export function isSystemUserFlag(value) {
    return value === '1' || String(value ?? '').toLowerCase() === 'true';
}

export async function fetchIsSystemUser(account, loginMethod) {
    const trimmedAccount = String(account ?? '').trim();
    if (!trimmedAccount) {
        return false;
    }

    const payload =
        loginMethod === 'phone'
            ? { phone: trimmedAccount }
            : { email: trimmedAccount };

    try {
        const response = await post('/user/getUserInfo', payload);
        const responseCode = response?.code;
        const isSuccessful =
            response?.success === true ||
            responseCode === 0 ||
            responseCode === '0';

        if (!isSuccessful) {
            return false;
        }

        return isSystemUserFlag(response?.data?.isSys);
    } catch (error) {
        console.warn('System user check failed:', error);
        return false;
    }
}
